var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{attrs:{"src":_vm.getUrl,"max-width":_vm.size,"max-height":_vm.size}})}
var staticRenderFns = []

export { render, staticRenderFns }